import { createTheme } from "@mui/material";

export const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "Myriad Pro, sans-serif",
    },
  },
});
